// SD35: the DS stylesheet first, then the feature CSS. These imports must stay above `./App`:
// Vite emits CSS in import order, and every page's own stylesheet comes in through App.
import "@grackle/ui/styles.css";
import "./styles/base.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { loadDesktopInfo } from "./desktop";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element not found");
}

// SD7: when this bundle is inside the Tauri shell, load native config (API origin,
// recoverable local recordings) before the first fetch so session cookies and FR-RD7
// recovery hit the right place.
void loadDesktopInfo().finally(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
